// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const menuToggle = document.querySelector('.xa-nav-toggle');
    const menu = menuToggle.parentElement;

    let scrollOffset = 0;

    menuToggle.addEventListener('click', () => menu.classList.toggle('is-open'));

    window.addEventListener('scroll', () => {
        const previousOffset = scrollOffset;
        scrollOffset = document.documentElement.scrollTop;

        if (menu.classList.contains('is-open')) {
            return;
        }

        if (scrollOffset < Math.max(previousOffset, 100)) {
            menu.classList.add('is-active');
            return;
        }

        menu.classList.remove('is-active');
    });
}
